







import Vue from 'vue'
import ReviewForm from '@/UI/UserProcedures/BidProcedures/Review/ReviewForm.vue'
import {
  FetchReviewedDocumentationCommandHandlerProvider
} from '@/Infrastructure/ReviewedDocumentation/Provider/FetchReviewedDocumentationCommandHandlerProvider'
import {
  FetchReviewedDocumentationCommand
} from '@/Application/ReviewedDocumentation/'
import { ReviewedDocumentationDTO } from '@/Application/ReviewedDocumentation/ReviewedDocumentationDTO'
import { EventBus } from '@/Infrastructure/EventBus/EventBus'

interface ReviewedDocumentationInt {
  reviewDoc: ReviewedDocumentationDTO | null;
}

export default Vue.extend({
  name: 'ReviewLayout',
  components: {
    ReviewForm
  },
  props: {
    procedureId: {
      type: String,
      required: true
    },
    accountId: {
      type: String,
      required: true
    }
  },
  data (): ReviewedDocumentationInt {
    return {
      reviewDoc: null
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData (): Promise<void> {
      EventBus.$emit('loading', true)
      return this.loadBatches()
        .then((response: ReviewedDocumentationDTO) => {
          this.reviewDoc = response
        })
        .finally(() => {
          EventBus.$emit('loading', false)
        })
    },
    loadBatches (): Promise<ReviewedDocumentationDTO> {
      const provider = new FetchReviewedDocumentationCommandHandlerProvider()
      const command = new FetchReviewedDocumentationCommand(this.accountId, this.procedureId)
      const handler = provider.provide()
      return handler.handle(command)
    }
  }
})
